import { parseISO } from 'date-fns';

/**
 * Parse a date-only string ("2026-04-07") as local midnight.
 * Avoids the UTC-midnight bug from new Date("2026-04-07").
 */
export function parseLocalDate(dateStr) {
  if (!dateStr) return new Date();
  // parseISO treats date-only strings as local time
  return parseISO(dateStr);
}

/**
 * Convert 24-hour time string to 12-hour format.
 * "14:00" → "2:00 PM", "09:30" → "9:30 AM"
 */
export function formatTime12h(time24) {
  if (!time24) return '';
  const [hourStr, minuteStr] = time24.split(':');
  let hour = parseInt(hourStr, 10);
  const minute = minuteStr || '00';
  const ampm = hour >= 12 ? 'PM' : 'AM';
  if (hour === 0) hour = 12;
  else if (hour > 12) hour -= 12;
  return `${hour}:${minute} ${ampm}`;
}

/**
 * Format a time range in 12-hour format.
 * ("09:00", "14:00") → "9:00 AM - 2:00 PM"
 */
export function formatTimeRange(startTime, endTime) {
  if (!startTime) return '';
  const start = formatTime12h(startTime);
  if (!endTime) return start;
  return `${start} - ${formatTime12h(endTime)}`;
}
